<template>
  <a-card class="m-t-10" :bordered='false'>
    <a-button size='small' @click="()=>{$router.go(-1)}">
      <LeftOutlined />返回
    </a-button>
    <span class="ml15 card_title" >扫码活动详情</span>
  </a-card>
  <a-card :bordered="false">
    <!-- 活动信息 -->
    <div class=" s_over_h mb25">
      <div class="s_fonts18 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333 mb25">活动信息</div>
      <div class="s_ptb0lr24">
        <a-form-item label="活动名称"> {{detail.activity_name}} </a-form-item>
        <a-form-item label="活动时间"> {{detail.start_time}} ~ {{detail.end_time}} </a-form-item>
        <a-form-item label="扫码模板"> {{detail.template_name}} </a-form-item>
        <a-form-item label="活动规则"> 
          <p class="width50 rule_content_box" v-html="detail.rule_content"></p>
        </a-form-item>
        <a-form-item label="活动备注"> {{detail.remarks || '-'}} </a-form-item>
        <a-form-item label="添加时间"> {{detail.created_time}} </a-form-item>
      </div>
    </div>
    <div class=" s_over_h mb25">
      <div class="s_fonts18 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333 mb25">活动范围</div>
      <div class="s_ptb0lr24 s_shou" @click="rangeVisible=true">活动码总数：<span class="text-uline s_c376">{{awardDetail.total}}</span></div>
    </div>
    <div class=" s_over_h mb25">
      <div class="s_fonts18 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333 mb25">活动奖项</div>
      <div class="s_ptb0lr24">
        <award :awardList="awardList" :detail="awardDetail" :template_type="detail.template_type"  />
      </div>
    </div>
    <div class=" s_over_h mb25">
      <div class="s_fonts18 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333 mb25">活动策略</div>
      <div class="s_ptb0lr24">
        <a-tabs >
          <a-tab-pane key="1" tab="数据收集策略" v-if="ployDetail.is_open_collect_data">
            <a-form-item label="自动打标签" :wrapper-col="{span:20}">
                  <a-card>
                     <a-form-item label="条件" :label-col="{span:2}">
                      第{{ployDetail.collect_data_second}}次扫码领奖时收集用户资料
                  </a-form-item>
                    <a-form-item label="标签" :label-col="{span:2}">
                        <template v-for="v in custimizesList" :key="v.id">
                          <a-tag color="blue" v-if="v.is_select" class="m-r-10">{{v.customize_name}}</a-tag>
                        </template>
                  </a-form-item>
                  </a-card>
            </a-form-item>
          </a-tab-pane>
          <a-tab-pane key="2" tab="用户参与策略" v-if="$route.query.activity_type==1">
            <a-card>
               <a-empty />
            </a-card>
            <!-- <a-form-item label="领奖限制">

            </a-form-item>
            <a-form-item label="活动参与限制">
            </a-form-item> -->
          </a-tab-pane>
          <a-tab-pane key="3" tab="奖品发放策略" v-if="$route.query.activity_type==1">
            <a-form-item label="未中奖提醒">
                {{ployDetail.ploy_remark}}
            </a-form-item>
             <a-form-item label="奖品发放策略" :wrapper-col="{span:20}">
              <a-table :pagination='false' :loading='listLoading'  bordered rowKey='ploy_id' :columns='columns' :data-source='data'>
                   <template v-slot:rule_name_arr="{ record }">
                 <p v-for="v in record.rule_name_arr" :key="v">{{v}}</p>
                </template>
                  <template v-slot:award_name_arr="{ record }">
                 <p v-for="v in record.award_name_arr" :key="v">{{v}}</p>
                </template>
                <template v-slot:action="{ record }">
                    <a-popconfirm title="确定要删除该策略么？" @confirm="ployDel(record)" ok-text="删除" cancel-text="取消" placement="topRight">
                         <a-button type="danger"  class="m-t-20">删除</a-button>
                  </a-popconfirm>
                  <a-button type="primary"  class="m-l-10" @click="ployStatus(record)">{{record.is_enable?'禁用':'启用'}}</a-button>
                  <a-button type="primary"  class="m-l-10" @click="editPloy(record)">编辑</a-button>
                </template>
              </a-table>
            </a-form-item>
          </a-tab-pane>
        </a-tabs>
        <!-- <a-form-item label="获取用户地理位置">
        </a-form-item>
        <a-form-item label="是否强制获取地理位置">
        </a-form-item> -->
      </div>
    </div>
  </a-card>
  <a-modal v-model:visible="rangeVisible" title="活动范围" centered :width='1000' :footer="null" destroyOnClose>
    <range :activity_id="activity_id || $route.query.activity_id" :is_detail="true" />
  </a-modal>
</template>

<script>
import { LeftOutlined } from "@ant-design/icons-vue";
import { inject, onMounted, reactive, toRefs } from "vue";
import range from "../../components/range/index.vue";
import award from "../../components/award/index.vue";
import {
  activitysOneDetail,
  activitysTreeList,
  activitysFourPloysList,
  activitysFourCustomizesSelectList,
  activitysFourDetail,
} from "@/api/qrcodeActivitys";
    let columns = [
      {
        title: "优先级",
        dataIndex: "sort_level",
        key: "sort_level"
      },
      {
        title: "名称",
        dataIndex: "ploy_name",
        key: "ploy_name",
      },
      {
        title: "规则策略",
        dataIndex: "rule_name_arr",
        key: "rule_name_arr",
       slots: { customRender: "rule_name_arr" },
      },
      {
        title: "奖项设置",
        dataIndex: "award_name_arr",
        key: "award_name_arr",
       slots: { customRender: "award_name_arr" },
      },
      {
        title: "状态",
        dataIndex: "is_enable",
        key: "is_enable",
        customRender:({record})=>{
            return record.is_enable?'启用':'禁用'
        } 
      },
    ];
import { message } from "ant-design-vue";
import { iscode } from "../../../../utils/app";
export default {
  components: { range, award,LeftOutlined },
  props:{activity_id:String},
  setup(props) {
    const $route = inject("$route");
    const state = reactive({
      awardList: [],
      awardDetail:{},
      detail: {},
      ployDetail: {},
      listLoading:false,
      data:[],
      custimizesList:[],
      rangeVisible:false
    });
    // 获取详情
    const getDetail = async () => {
      let result = await activitysOneDetail(props.activity_id||$route.query.activity_id)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result)) {
        state.detail = result.data;
      } else {
        message.error(result.message);
      }
    };
    // 活动奖项
    const getAward = async () => {
      let result = await activitysTreeList(props.activity_id||$route.query.activity_id)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result)) {
        state.awardList = result.data;
        state.awardDetail=result

      } else {
        message.error(result.message);
      }
    };
    // 策略详情
    const ploy = async () => {
      let result = await activitysFourDetail(props.activity_id||$route.query.activity_id)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result)) {
        state.ployDetail = result.data;
      } else {
        message.error(result.message);
      }
    };
    // 策略列表
        const getPloysList = async () => {
      state.listLoading=true
      let result = await activitysFourPloysList(props.activity_id||$route.query.activity_id)
        .then((res) => res.data)
        .catch((error) => error);
       state.listLoading=false
      if(iscode(result)){
        state.data=result.data
      }
    };
    // 标签列表
    const getcustimizesList = async () => {
      let result = await activitysFourCustomizesSelectList(props.activity_id||$route.query.activity_id)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result)) {
        state.custimizesList = result.data;
      }
    };
    onMounted(() => {
      getAward();
      getDetail();
      ploy();
      getPloysList();
      getcustimizesList()
    });
    return {
      ...toRefs(state),
      columns
    };
  },
};
</script>
<style>
  .rule_content_box img{width:100%}
</style>